import styled, { css } from 'styled-components';
import Link from 'components/Link';

export const WaterMarkStyled = styled.div`
  cursor: default;
  pointer-events: none;
  user-select: none;
  opacity: 0.5;
  transition:
    bottom 95ms ease-in-out,
    opacity 135ms ease-in-out;
  font-size: 0;
  ${(props) =>
    props.clickable &&
    css`
      cursor: pointer;
      pointer-events: auto;
    `} ${(props) =>
    props.size === 's' &&
    css`
      width: 80px;
      height: 12px;
    `} {
    opacity: 0.9;
  }
`;

export const StyledImg = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`;

export const StyledLink = styled(Link)`
  width: 100%;
`;
